export const PREMIUM_CALCULATORS = {
  activations: "activations",
  apartmentPlan: "apartmentPlan",
  destinyMatrix: "destinyMatrix",
} as const;

export const PURCHASABLE_CALCULATORS = [
  PREMIUM_CALCULATORS.destinyMatrix,
] as const;

export const SUBSCRIPTION_TIERS = {
  consultant: "consultant",
  individual: "individual",
  family: "family",
  daily: "daily",
  yearly: "yearly",
} as const;

export type PremiumCalculator =
  (typeof PREMIUM_CALCULATORS)[keyof typeof PREMIUM_CALCULATORS];

export type PurchasableCalculator = (typeof PURCHASABLE_CALCULATORS)[number];

export type SubscriptionTier =
  (typeof SUBSCRIPTION_TIERS)[keyof typeof SUBSCRIPTION_TIERS];
